import script from "./ResolveList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResolveList.vue?vue&type=script&lang=ts&setup=true"

import "./ResolveList.vue?vue&type=style&index=0&id=67727235&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67727235"]])

export default __exports__